import { TmBaseComponent } from '@treasury/presentation';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

export const tagName = 'ach-filters-container';
@customElement(tagName)
export class AchFiltersContainer extends TmBaseComponent {
    public render() {
        return html`<div>ACH Filters</div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: AchFiltersContainer;
    }
}
